import Actions from '../Collection/actions'

const actions = Actions.get('THEMATIC_');

export default actions;
